import { Box, Image, Text } from "grommet";
import * as React from "react";
import styled from "styled-components";
import Flag from "../components/Flag";
import { TransparentBlock } from "../components/TransparentBlock";

let Badge = styled.img`
    border-radius: 18px;
    padding: 0.2rem;
    width: 50px;
`;

const TeamHeader = ({ name, countryCode, logoUri, splashUri, rating }) => {
    return (
        <div>
            <Box pad="medium" background={{ image: "url(" + splashUri + ")", color: "rgba(0,0,0,0.7)" }} round={{ corner: "bottom", size: "5px" }}>
                <Box direction="row" align="center">
                    <Box pad={"small"}>
                        <Image src={logoUri} fill style={{ maxWidth: "200px" }}></Image>
                    </Box>
                    <TransparentBlock>
                        <Box pad={"small"}>
                            <Text size={"xlarge"}>
                                {name}
                                <Flag country={countryCode} size={20}></Flag>
                            </Text>
                            {/* <div>
                                <Text size="small">Playing Minecraft Education Edition</Text>
                            </div> */}
                            {/* <Box direction="row" pad="xsmall" round="12px" background={"background"} justify="between" align="center">
                            <Badge src="/images/coin.png" />
                            <Badge src="/images/crown.png" />
                            <Badge src="/images/cupcake.png" />
                            <Badge src="/images/donut.png" />
                            <Badge src="/images/present.png" />
                            <Badge src="/images/trophy.png" />
                            <Text size="small">
                            View All <FontAwesomeIcon icon={["fad", "arrow-right"]}></FontAwesomeIcon>{" "}
                            </Text>
                        </Box> */}
                            {/* <Rating rating={rating}></Rating> */}
                        </Box>
                    </TransparentBlock>
                </Box>
            </Box>
        </div>
    );
};
``;

export default TeamHeader;
